"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function JetInputError(_a) {
    var message = _a.message, className = _a.className, children = _a.children;
    if (!message && !children) {
        return null;
    }
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("p", { className: "text-sm text-red-600" }, message || children)));
}
exports.default = JetInputError;
